import React from "react";
import { Link } from "react-router-dom";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";
import styles from "./breadcrumbs.module.scss";

const Breadcrumbs = ({ breadcrumbs }) => {
    const breadcrumbsWithoutArhiva = breadcrumbs.filter(el => el.key !== '/arhiva')
    return (
        <div className={styles.mainBreadcrumb}>
            <ul className={styles.listStyleBreadcrumbs}>
                {breadcrumbsWithoutArhiva.map(({ breadcrumb, match }, index) => {
                    return(
                    <li key={match.url}>
                        <Link to={match.url || ""}>{breadcrumb.props.children === 'Home' ? 'Početna' : breadcrumb}</Link>
                        {index < breadcrumbs.length - 2 && ' > '}
                    </li>)
                })}
            </ul>
        </div>)

};

export default withBreadcrumbs()(Breadcrumbs);
